import React from 'react';

export default function Overview({ data }) { // Fixed: destructure data properly
  return (
    <div className="data-overview card">
      <div className="card-header">
        <h3 className="card-title mb-0">Overview</h3>
      </div>
      <div className="items">
        <div className="data-box">
          <div className="count">{data?.piece_count || 0}</div>
          <div className="type">Pieces</div>
        </div>

        <div className="data-box">
          <div className="count">{data?.paid_piece_count || 0}</div>
          <div className="type">Priced Pieces</div>
        </div>
      </div>
    </div>
  );
}
